import { Component, Event, EventEmitter, h, Host, Prop, State } from "@stencil/core";
import { parseLinks } from "../../utils/utils";

@Component({
    tag: "legal-disclaimer",
    styleUrl: "legal-disclaimer.scss",
    shadow: false
})
export class LegalDisclaimer {
    private baseClass = "legal-disclaimer";

    /** The headline text to be displayed at the top of the disclaimer */
    @Prop() readonly headline: string = "";
    /** The label text for the submit button */
    @Prop() readonly buttonLabel: string = "";
    /** The label text for the checkbox */
    @Prop() readonly checkboxLabel: string | string[];

    /** Emitted when the user accepts the disclaimer by checking the checkbox and clicking submit */
    @Event() disclaimerSubmitted: EventEmitter<void>;

    @State() isCheckboxChecked = false;

    // Use onChange for more conventional checkbox handling.
    private handleCheckboxChange = (event: Event) => {
        const target = event.target as HTMLInputElement | null;
        if (target && typeof target.checked === "boolean") {
            this.isCheckboxChecked = target.checked;
        }
    };

    private handleSubmit = () => {
        if (this.isCheckboxChecked) {
            this.disclaimerSubmitted.emit();
        }
    };

    render() {
        return (
            <Host class={this.baseClass} role="region" aria-labelledby="disclaimer-header">
                <div class={`${this.baseClass}__content`}>
                    <ux-headline level="1" variant="big">
                        {this.headline}
                    </ux-headline>

                    <slot></slot>

                    <ux-checkbox
                        class={`${this.baseClass}__checkbox`}
                        value="checked"
                        label={typeof this.checkboxLabel === "string" ? this.checkboxLabel : ""}
                        name="input"
                        required={true}
                        onChange={this.handleCheckboxChange}
                    >
                        {Array.isArray(this.checkboxLabel) &&
                            this.checkboxLabel.map((label: string, index: number) => (
                                <span
                                    key={`checkbox-label-${index}`}
                                    class={`ux-text-normal ux-text-normal--light-gray ${this.checkboxLabel.length - 1 !== index ? `${this.baseClass}__checkbox-label` : ""}`}
                                    innerHTML={parseLinks(label)}
                                ></span>
                            ))}
                    </ux-checkbox>
                </div>
                <ux-button
                    variant="primary"
                    class={`${this.baseClass}__button`}
                    disabled={!this.isCheckboxChecked}
                    onClick={this.handleSubmit}
                >
                    {this.buttonLabel}
                </ux-button>
            </Host>
        );
    }
}
